import fyChatToast from './fyChatToast.vue'
const toast = {}
toast.install = Vue => {
    // 扩展 vue 插件
    const ToastCon = Vue.extend(fyChatToast)
    const ins = new ToastCon()
    // 挂载 dom
    ins.$mount(document.createElement('div'))
    // 添加到 body 后面
    document.body.appendChild(ins.$el)
    // 给 vue 原型添加 toast 方法
    Vue.prototype.$toast = (obj, duration = 1500) => {
        if(obj.constructor == Object){
            ins.message = obj.msg;
            ins.color = obj.color;
            ins.bgColor = obj.bgColor;
        }else{
            ins.message = obj;
        }
        ins.visible = true
        setTimeout(() => {
            ins.visible = false
        }, duration)
    }
}
export default toast